import React,{useState} from 'react'
import revise from '../../assets/stationary.jpg';
import { Link } from 'react-router-dom';
import '../../App.css';
const Study = () => {
    const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);
    return (
          <>
          <img src={revise} alt="revise" style={{width:'100%'}}/>
          <div style={{position:"absolute",top:"18%",left:'10%'}}>
          <h3>
          <a href="https://lets-learnreact.netlify.app/"> <span class="badge rounded-pill bg-secondary">React</span></a>
      <a href="https://lets-learnstyling.netlify.app/"> <span class="badge rounded-pill bg-secondary">Frontend Lib.</span></a>
      <a href="#"> <span class="badge rounded-pill bg-secondary">Data Structure</span></a>
      <a href="#"> <span class="badge rounded-pill bg-secondary">Algorithms</span></a>
      <a href="https://lets-learnoperatingsystem.netlify.app/"> <span class="badge rounded-pill bg-secondary">Operating System</span></a>
      <a href="#"> <span class="badge rounded-pill bg-secondary">DBMS</span></a>
        </h3>
         </div>
          </>
    )
}

export default Study
